export const spacingConfig = {
  outerPadding: 4,
  innerPadding: 12,
  size: {
    collapsed: 60,
    full: 242,
  },
}
